module.exports = __webpack_public_path__ + "img/light_tip_ico.451d4231.png";